export { default } from './gif-video.js'
